function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "contact_art_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-182.152 81.012l-2.042 8.269h-2.379a.793.793 0 00-.792.793.794.794 0 00.792.793h3a.792.792 0 00.77-.6l.675-2.734.051 6.795a.792.792 0 00.611.766.827.827 0 00.182.021.79.79 0 00.706-.433l1.994-3.907h1.361a.783.783 0 00.388-.1.534.534 0 00.241-.207.788.788 0 00.167-.484.8.8 0 00-.8-.8c-.016 0-.434 0-.472.006h-1.379a.79.79 0 00-.707.432l-.74 1.45-.073-9.871a.8.8 0 00-.7-.781.762.762 0 00-.091-.005.793.793 0 00-.771.6",
  transform: "translate(187.366 -80.41)",
  fill: "#fff"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-133.349 -92.55)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 233.759,
  cy: 52.064,
  rx: 233.759,
  ry: 52.064,
  transform: "translate(133.349 327.372)",
  fill: "rgba(0,255,255,0.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.478 208.051l-22.795 114.208h-4.934l-.543-.844-1.572-2.446 19.739-106.689 3-1.255z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468.37 211.026l-21.164 110.39-1.572-2.446 19.739-106.689z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M509.788 363.619l-5.86 1.889-1.424.461-1.88-4.23-32.258-147.13 3.353-.752 7.047-1.576z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M503.927 365.507l-1.424.461-1.88-4.23-32.257-147.123 3.353-.752z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.378 208.051l-5.17 148.047-5.925 1.316-.42.094-1.645-3.055 3.29-144.993 3.165-.451z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.673 209.01l-4.39 148.4-.42.094-1.645-3.055 3.29-144.993z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.162 408.503l-6.128 1.057-.686.117-1.88-3.995-29.845-193.4.86-.261 4.545-1.384z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.034 409.56l-.686.117-1.88-3.995-29.845-193.4.86-.261z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M390.88 196.067l22.819 29.157a7.4 7.4 0 006.688 2.789l93.672-10.971a7.4 7.4 0 006.539-7.349v-21.616z",
  fill: "#7a799c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M467.724 200.768h6.345v9.157a2.358 2.358 0 01-2.358 2.358h-1.63a2.358 2.358 0 01-2.358-2.358v-9.157z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.623 214.631l22.819 29.157a7.4 7.4 0 006.688 2.789l93.673-10.971a7.4 7.4 0 006.539-7.349v-21.616z",
  fill: "#7a799c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.466 219.331h6.345v9.158a2.358 2.358 0 01-2.358 2.358h-1.63a2.358 2.358 0 01-2.357-2.358v-9.157z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M248.839 229.398l278.629-32.456a4.1 4.1 0 001.369-7.729l-49.842-25.067a57.688 57.688 0 00-31.771-5.853l-247.54 25.241a4.738 4.738 0 00-2.9 8.019l28.826 29.575a27.984 27.984 0 0023.229 8.269zM558.121 192.543l-2.98-1.647s-3.218 2.368-5.839 12.347 4.9.108 4.9.108l3.29-6.815zM526.239 283.954s-3.055 14.335-4.465 18.33c-.691 1.955-4.028 3.743-7.727 5.111a51.732 51.732 0 01-10.133 2.644c-3.995.47-55.224-7.52-80.134-12.925-16.781-3.64-18.95-7.816-18.579-10.152a3.389 3.389 0 01.954-1.833s24.675-16.684 33.375-24.674 25.85-1.645 44.649 1.645 42.06 21.854 42.06 21.854z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555.14 190.896s11.515 7.52-27.26 23.03c0 0-21.075 11.883-18.332 60.832a13.424 13.424 0 001.951 6.217c4 6.58 12.573 23.236-1.714 25.3v3.76s25.849-12.925 28.669-23.97 12.22-72.379 16.92-78.019 7.756-14.567-.234-17.15z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514.046 307.395a51.725 51.725 0 01-10.133 2.644c-3.995.47-55.224-7.52-80.134-12.925-16.781-3.64-18.95-7.816-18.579-10.152 11.031 3.772 46.849 15.742 59.7 16.732 15.275 1.175 44.456 4.441 46.668 2.221.854-.856 1.724.047 2.478 1.48z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M379.835 405.21l22.325-101.988s3.995-10.81 13.16-10.34l8.46 4.23s-14.1-3.29-17.155 7.52-22.56 100.578-22.56 100.578zM433.414 358.683l8.93-62.274h4l-9.17 62.274zM518.955 419.548l-8.456-97.286s0-8.225 4.23-12.22 17.885-15.391 17.885-15.391 3.5-.824 6.319 7.166 22.325 87.888 22.325 87.888l-3.76 1.645-24.206-92.118-16.685 15.745s-3.29 5.875-1.645 11.28 7.755 93.293 7.755 93.293z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M492.868 307.689l21.149 6.11 4.7-4.465-12.22-1.645z",
  fill: "#47465a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.847 136.167l3.429 51.44 74.971-7.285-2.983-50.284a5.057 5.057 0 00-5.472-4.74l-65.316 5.494a5.057 5.057 0 00-4.629 5.375z",
  fill: "#7a799c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.389 195.125l-74.729 8.152-2.82.308-21.854-14.1v-3.055l74.258-6.688z",
  fill: "#7a799c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.658 203.278l-2.82.308-21.854-14.1v-2.736z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.924 135.672l2.585 45.824 65.8-6.11-2.35-44.65z",
  fill: "#9493b6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.168 194.186l7.99 5.405 24.2-2.35-8.225-5.17z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M316.504 187.606l10.1 7.52 64.624-6.11-11.515-7.52z",
  fill: "#9493b6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6584",
  d: "M431.181 118.165h47.704v47.704h-47.704z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M431.181 118.165h47.704v47.704h-47.704z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.611 140.241s6.729 18.226 0 21.59 24.114 0 24.114 0l8.692-7.01s-19.628-5.608-16.824-18.506-15.982 3.926-15.982 3.926z",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.611 140.241s6.729 18.226 0 21.59 24.114 0 24.114 0l8.692-7.01s-19.628-5.608-16.824-18.506-15.982 3.926-15.982 3.926z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.373 323.059s25.236 35.61 21.03 45.424-1.963 15.983-10.375 19.347-10.655 9.534-3.365 9.253 16.824-2.243 18.226-4.767 4.767-14.581 9.534-16.263 13.739-8.132 7.29-15.983-22.7-36.769-21.444-39.695-20.896 2.684-20.896 2.684z",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M445.086 252.68s-52.154 3.365-65.612 15.983 11.777 59.724 14.581 60.285 24.675-1.682 23.834-7.851-15.7-31.4-15.7-31.4 19.347-7.01 30-8.692 22.431-9.537 22.431-9.537z",
  fill: "#09bfff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.253 244.829s.841 31.124 8.692 32.245 0-23.834 0-23.834l-.28-9.533z",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M445.087 163.233s-14.581-4.206-17.385 7.01-3.645 49.91-3.645 49.91l-5.042 30.844s9.253-2.8 11.216-1.4l11.777-14.861z",
  fill: "#09bfff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M445.087 163.233s-14.581-4.206-17.385 7.01-3.645 49.91-3.645 49.91l-5.042 30.844s9.253-2.8 11.216-1.4l11.777-14.861z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M465.009 329.03s9.8 19.264 15.687 18.984 11.5-3.926 14.3 7.571-.561 8.412 2.8 15.141 3.926 18.506-2.523 21.31-12.337 3.084-12.618 0 5.608-3.084-1.122-14.02-21.03-30.844-26.918-32.806 10.394-16.18 10.394-16.18z",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M490.511 241.184s20.188 33.648 7.01 43.461-52.434 28.6-52.434 28.6 21.03 14.3 22.151 19.067-10.094 17.665-14.02 17.945-15.422-12.9-27.759-16.263-19.908-27.479-6.449-36.451 26.077-23.832 26.077-23.832l-3.923-21.587z",
  fill: "#09bfff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.011 128.975c0 11.924-12.215 21.781-24.139 21.781a21.59 21.59 0 110-43.181c11.924 0 24.139 9.475 24.139 21.4z",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454.34 160.149s19.347-8.412 19.347-9.534 11.216 2.524 13.739 4.767 3.926 1.963 5.608 6.449-8.412 46.265-8.412 46.265 5.608 32.245 8.692 35.33-24.955 7.571-24.955 7.571-18.506 3.365-21.591 4.767-8.692 3.365-7.571 0 5.888-5.888-2.243-10.094c0 0 2.8-13.739 0-19.908s-15.7-28.6-5.328-44.863 15.141-22.151 15.141-22.151 3.647 3.084 7.573 1.401z",
  fill: "#09bfff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.508 236.697s-21.871 9.7-28.46 10.6-26.5 5.945-15.562 10.431 27.479-2.243 27.479-2.243l23.273-9.814z",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484.056 159.289s8.076-3.907 10.319 9.833 10.094 57.2 0 63.65-33.362 16.823-33.362 16.823-13.739-9.253-7.29-12.618 21.871-12.9 24.114-16.263 4.51-40.922.584-47.091 5.635-14.334 5.635-14.334z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M483.501 155.944s11.216-.561 13.459 13.179 10.094 57.2 0 63.65-33.367 16.824-33.367 16.824-13.739-9.253-7.29-12.618 21.871-12.9 24.114-16.263-1.682-38.415-5.608-44.583 8.692-20.189 8.692-20.189z",
  fill: "#09bfff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443.554 92.82c-3.442.468-7.134 1.728-8.867 4.739-.848 1.474-1.122 3.2-1.774 4.772-1.8 4.331-6.178 6.918-9.337 10.386-4.117 4.519-6.162 11.33-3.734 16.94.94 2.173 2.467 4.034 3.625 6.1 3.231 5.761 3.4 12.679 3.495 19.283l.181 12.985a18.661 18.661 0 01-.547 5.9 6.314 6.314 0 01-3.821 4.259 9.9 9.9 0 0011.533-3.938 10.12 10.12 0 01-3.093 8.978c5.141-1.211 9.451-4.95 12.167-9.479a36.736 36.736 0 004.54-15.049 19.728 19.728 0 00-.474-8.3 25.992 25.992 0 00-2.719-5.223c-2.638-4.332-5.014-8.939-5.864-13.939s0-10.486 3.25-14.383a12.992 12.992 0 0110.261-4.705 11.424 11.424 0 019.525 5.831c.75 1.412 1.818 3.326 3.338 2.829a8.249 8.249 0 00.823-.4c1.7-.771 3.62.75 4.368 2.456 2.357 5.38-1.986 11.253-2.435 17.11-.418 5.448 2.62 10.586 6.251 14.669a48.2 48.2 0 0023.563 14.477 6.614 6.614 0 01-3.418-2.123 44.876 44.876 0 0011.027-.924 76.02 76.02 0 01-11.212-9.654 25.494 25.494 0 01-6.613-13.026c-.953-6.561 1.49-13.666-1.3-19.679-2.554-5.5-8.889-8.569-11.2-14.171-2.35-5.691-3.873-10.635-10.1-13.112-6.793-2.712-14.103-4.607-21.439-3.609z",
  fill: "#2f2e41"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M335.365 49.965c-7.952 3.308-12.422 12.031-21.1 8.857-1.172-1.954-4.038-1.3-6.383-12.374l28.4-4.82c-1.703 5.211-1.964 3.257-.917 8.337z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M207.862 59.49l-1.607 8.364-2.376.124a.793.793 0 00-.749.834.794.794 0 00.832.75l2.996-.157a.792.792 0 00.738-.64l.53-2.765.407 6.783a.792.792 0 00.65.733.827.827 0 00.184.012.79.79 0 00.682-.47l1.787-4.006 1.334-.07h.025a.783.783 0 00.382-.121.534.534 0 00.23-.22.788.788 0 00.141-.491.8.8 0 00-.84-.758c-.016.001-.434.023-.471.031l-1.378.072a.79.79 0 00-.683.469l-.663 1.486-.59-9.853a.8.8 0 00-.74-.743.762.762 0 00-.09 0 .793.793 0 00-.74.639",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-3 1230.948 -3839.355)",
  clipPath: "url(#contact_art_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-4.493 1.533L9.801-3.344l5.634 16.512L1.14 18.045z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M211.898 79.126a15.124 15.124 0 01-15.877-14.3 15.124 15.124 0 0114.296-15.87 15.124 15.124 0 0115.875 14.29 15.124 15.124 0 01-14.295 15.875m-1.497-28.55a13.5 13.5 0 00-12.758 14.17 13.5 13.5 0 0014.17 12.76 13.5 13.5 0 0012.759-14.17 13.5 13.5 0 00-14.17-12.76",
  fill: "#fefefe"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.242 63.01a3.944 3.944 0 00-1.263-1.168 3.183 3.183 0 00.607-.946 3.231 3.231 0 00.238-1.427 3.162 3.162 0 00-.318-1.243 3.274 3.274 0 00-.745-.983 3.266 3.266 0 00-1.056-.639 3.146 3.146 0 00-1.27-.185l-4.965.26a.76.76 0 00-.524.246.718.718 0 00-.206.548l.04.77 5.735-.3a1.622 1.622 0 01.665.102 1.772 1.772 0 01.558.336 1.763 1.763 0 01.392.52 1.617 1.617 0 01.171.65 1.614 1.614 0 01-.102.663 1.871 1.871 0 01-.337.569 1.6 1.6 0 01-.515.387 1.706 1.706 0 01-.653.166l-2.46.129a.542.542 0 00-.076-.002.776.776 0 00-.732.813.871.871 0 00.662.747l2.866-.156a2.213 2.213 0 01.887.133 2.319 2.319 0 01.757.454 2.319 2.319 0 01.531.706 2.218 2.218 0 01.225.869 2.26 2.26 0 01-.131.908 2.223 2.223 0 01-.454.747 2.609 2.609 0 01-1.854.704 62.25 62.25 0 01-1.013.03c.14.006.68 1.514.463 1.564l.06-.003a.565.565 0 00.081-.011h.006c2.517-.124 3.103-.924 3.426-1.281a3.761 3.761 0 00.743-1.25 3.756 3.756 0 00.214-1.482 3.666 3.666 0 00-.652-1.936",
  fill: "#fefefe"
}));

function SvgContactArt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467.518,
    height: 338.95,
    viewBox: "0 0 467.518 338.95"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "static/contact_art.ad76e0e4.svg";
export { SvgContactArt as ReactComponent };